import { Rule } from 'src/app/core';
import {
  RulesPermission,
  SetupPage,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Settings } from '../../../developer-settings.setup';

const parent: SetupPage = Settings.pages.webhooksManagement;
const path = 'webhooks';
const title = 'PAGE.DEVELOPER_SETTINGS.WEBHOOKS_MANAGEMENT.WEBHOOKS.TITLE';
const res = [
  'createWebhook',
  'actions',
  'actions.activateWebhook',
  'actions.pauseWebhook',
  'actions.deleteWebhook',
  'actions.editWebhook',
  'actions.testWebhook',
];

export const SettingsWebhooksManagementWebhooksTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
